var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17969 5.63477C0.765474 5.63477 0.429688 5.97055 0.429688 6.38477C0.429687 6.79898 0.765474 7.13477 1.17969 7.13477L1.17969 5.63477ZM22.71 6.9151C23.0029 6.6222 23.0029 6.14733 22.71 5.85444L17.937 1.08147C17.6442 0.788573 17.1693 0.788573 16.8764 1.08147C16.5835 1.37436 16.5835 1.84923 16.8764 2.14213L21.119 6.38477L16.8764 10.6274C16.5835 10.9203 16.5835 11.3952 16.8764 11.6881C17.1693 11.981 17.6442 11.981 17.937 11.6881L22.71 6.9151ZM1.17969 7.13477L22.1797 7.13477L22.1797 5.63477L1.17969 5.63477L1.17969 7.13477Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIcon);
export default __webpack_public_path__ + "static/media/button-icon.d07fc16f1d6985d0a36bf67d922da726.svg";
export { ForwardRef as ReactComponent };